import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function useList(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const reload = useCallback(() => { api.get(path).then((r) => setData(r.data)).catch((e) => setError(errMsg(e))); }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return { data, error, reload };
}

export async function post(path, body, msg, reload) {
  try { await api.post(path, body); toast.success(msg || "Gespeichert"); reload && reload(); } catch (e) { toast.error(errMsg(e)); }
}

export function Table({ cols, rows, testId, empty = "Keine Einträge" }) {
  return (
    <div className="w-card overflow-x-auto" data-testid={testId}>
      <table className="w-full text-left">
        <thead className="bg-gray-50 border-b border-line"><tr>{cols.map((c) => <th key={c[0]} className="px-4 py-3 text-sm font-bold uppercase tracking-wide w-muted whitespace-nowrap">{c[0]}</th>)}</tr></thead>
        <tbody>
          {!rows?.length && <tr><td colSpan={cols.length} className="px-4 py-8 text-center w-muted">{empty}</td></tr>}
          {rows?.map((r, i) => <tr key={r.id || i} className="border-b border-line last:border-0 align-top">{cols.map((c) => <td key={c[0]} className="px-4 py-3">{c[1](r)}</td>)}</tr>)}
        </tbody>
      </table>
    </div>
  );
}

export function FormDialog({ open, onClose, title, fields, onSubmit }) {
  const [vals, setVals] = useState({});
  useEffect(() => { if (open) setVals(Object.fromEntries(fields.map((f) => [f.name, f.default ?? ""]))); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <form className="space-y-4" data-testid="admin-form-dialog" onSubmit={async (e) => { e.preventDefault(); await onSubmit(vals); onClose(); }}>
          {fields.map((f) => (
            <label key={f.name} className="block"><span className="w-label">{f.label}</span>
              {f.options ? (
                <select className="w-input" value={vals[f.name] ?? ""} onChange={(e) => setVals({ ...vals, [f.name]: e.target.value })} data-testid={`dialog-${f.name}`}>
                  {f.options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              ) : (
                <input className="w-input" type={f.type || "text"} step="0.01" value={vals[f.name] ?? ""} onChange={(e) => setVals({ ...vals, [f.name]: e.target.value })} data-testid={`dialog-${f.name}`} />
              )}
            </label>
          ))}
          <button className="w-btn w-btn-primary w-full" data-testid="dialog-submit-btn">Bestätigen</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function useDialog() {
  const [cfg, setCfg] = useState(null);
  const el = cfg ? <FormDialog open onClose={() => setCfg(null)} {...cfg} /> : null;
  return [el, setCfg];
}

export const PageTitle = ({ children, sub }) => (
  <div className="mb-6"><h1 className="text-3xl font-extrabold">{children}</h1>{sub && <p className="w-muted">{sub}</p>}</div>
);
